<template>
  <div class="product-container">
    <slot />
<!-- 
    <template v-if="caseList.length > 0">
      <div class="case-content-title">
        <span>了解更多 产品及其他行业解决方案</span>
        <i style="width: 205px"></i>
      </div>
      <div class="case-content">
        <div
          class="case-content-item"
          v-for="item in caseList"
          @click="toDeatil(item)"
          :key="item.id"
        >
          <div class="img">
            <img v-lazy="item.img" alt="cover" />
          </div>
          <div class="item-text">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="money" v-if="item.type === 'target'">
              项目实施地：{{ item.target }}
            </div>
            <div class="money" v-else>
              营收：<span>{{ item.money }}</span
              >{{ item.currency }}/年
            </div>
            <div class="line"></div>
            <div class="text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="read-all">
        <div class="more" @click="$router.push({ name: 'industrySolutions' })">
          查看全部<img
            v-lazy="require('../../../assets/img/case/right-arrow.png')"
            alt="arrow"
          />
        </div>
      </div>
    </template>
    <div class="empty" v-else></div> -->
  </div>
</template>
<script>
import cases from "../../solutions/cases";
export default {
  name: "ProductContainer",
  props: {
    caseIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    caseList() {
      return this.caseIds
        .map((id) => cases.find((item) => item.id === id))
        .filter((item) => item);
    },
  },
  methods: {
    toDeatil(item) {
      this.$router.push({ name: "CaseDetail", params: { id: item.id } });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.product-container {
  width: 100%;
  background-color: #f6f6f6;

  .case-content-title {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 90px;
    margin-top: 100px;
    span {
      font-size: 36px;
      font-family: "MiSans-Semibold-";
      color: #00094c;
      line-height: 1;
      letter-spacing: 4px;
    }
    i {
      width: 100px;
      height: 4px;
      background: #1d56de;
      display: inline-block;
      margin-top: 40px;
    }
  }
  .case-content {
    max-width: 1500px;
    background-color: #f6f6f6;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 auto -80px;
    transform: scale(0.84);
    transform-origin: top;

    .case-content-item {
      width: 415px;
      // width: calc(33.33% - 48px);
      box-shadow: 11px 0px 30px 0px #ddd;
      margin-bottom: 80px;
      margin-right: 72px;
      transition: all 0.2s;
      cursor: pointer;

      &:hover {
        box-shadow: 11px 0px 30px 0px #bbb;
        // box-shadow: 4px 4px 9px -8px #000;
        transform: scale(1.05);
      }

      .img {
        width: 100%;
        height: 277px;
        overflow: hidden;
      }

      &:nth-of-type(3n),
      &:last-of-type {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 277px;
      }
      .item-text {
        padding: 27px 36px;

        .title {
          font-size: 27px;
          line-height: 32px;
          font-family: "MiSans-Semibold-";
          color: #000735;
        }
        .money {
          margin-top: 13px;
          font-size: 24px;
          line-height: 28px;
          font-family: "MiSans-Light-";
          color: #010734;

          > span {
            color: #010734;
            font-family: "MiSans-Demibold-";
          }
        }
        .line {
          width: 100%;
          height: 2px;
          background-color: #d4d4d4;
          margin: 0 auto;
          margin-top: 32px;
        }
        .text {
          margin-top: 27px;
          font-size: 24px;
          font-family: "MiSans-Demibold-";
          color: #010734;
          line-height: 32px;
        }
      }
    }
  }
  .read-all {
    width: 1180px;
    font-size: 24px;
    font-family: "MiSans-Medium-";
    color: #00094c;
    letter-spacing: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 140px;
    margin: 0 auto;

    .more {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    img {
      width: 10px;
      height: auto;
    }
  }

  .empty {
    height: 160px;
  }

  .zixun {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 185px;
    height: 50px;
    color: #ffffff;
    font-size: 20px;
    font-family: "MiSans-Normal-";
    letter-spacing: 2px;
    background-color: #1d55de;
    text-decoration: none;
    margin-top: 40px;
    cursor: pointer;

    .arrow-right {
      width: 12px;
      height: 12px;
      border-top: 2px solid #ffffff;
      border-right: 2px solid #ffffff;
      transform: rotate(45deg);
      margin-left: 4px;
    }
  }
}
/* 定义动画 */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes move-in {
  0% {
    opacity: 0;
    transform: translateY(500px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes moveUpDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-16px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes down_in {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-16px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>




// WEBPACK FOOTER //
// src/view/products/components/ProductContainer.vue